import { ProjectForm } from '../../project/models/form.model';
import { formTypes } from '../../form/form.constants';
import { BusinessInformation } from './business-information.model';
import { ResearchAndDevelopmentInformation } from './research-and-development-information.model';
import { SbirCalculation } from './sbir-calculation.model';
import { ManagerTaxCreditCalculation } from './manager-tax-credit-calculation.model';
import { CreditIssuance } from './credit-issuance.model';
import { RdFormType } from './rd-form-type';

export class SbirApplication extends ProjectForm {
  type: RdFormType;
  businessInformation: BusinessInformation;
  researchAndDevelopmentInformation: ResearchAndDevelopmentInformation;
  taxCreditCalculation: SbirCalculation;
  managerTaxCreditCalculation: ManagerTaxCreditCalculation;
  creditIssuance: CreditIssuance;

  constructor(formIndex: number = null) {
    super(formIndex);
    this.init();
  }

  init(): SbirApplication {
    super.init();
    this.type = <RdFormType>formTypes.rdSbir.abbrev;

    this.businessInformation = this.businessInformation || new BusinessInformation();
    this.researchAndDevelopmentInformation = this.researchAndDevelopmentInformation || new ResearchAndDevelopmentInformation();
    this.taxCreditCalculation = this.taxCreditCalculation || new SbirCalculation();
    this.managerTaxCreditCalculation =
      this.managerTaxCreditCalculation || new ManagerTaxCreditCalculation();
    this.creditIssuance = this.creditIssuance || new CreditIssuance();

    return this;
  }

  get qualifier(): string {
    return null;
  }
}
